export default function FormInputNumber({ labelClassName, className, id, name, label, min, max, ...other }) {
    return <div className={`input-number input-number__wrapper ${className ? className : ''}`}>
        <label className={`input-number__label ${labelClassName} margin__right--xxs`} htmlFor={id}>
            {label}
        </label>
        <input className={`input-number__input`} type="number" min={min} max={max} step="1" name={name} id={id} {...other} />
    </div>
}